import { State, useRealTimeStore } from '@hotjar/webapp/features/Playbacks/store/realTimeStore';
import { StateSelector, StateListener } from 'zustand/vanilla';

const nonReactSubscribeToCurrentTime = (
  selector: StateListener<State>,
  updateFn: StateSelector<State, State>,
) => useRealTimeStore.subscribe(selector, updateFn);

// Heatmap Screenshot Retaker events to allow picking custom time from Recording
export const subscribeAndSendCurrentTimeToHeatmaps = (): void => {
  nonReactSubscribeToCurrentTime(
    (state: State) => state.currentTime,
    (state: State) => {
      const { currentTime } = state;

      try {
        window.parent.postMessage(
          {
            event: 'hm_retaker_event',
            payload: { currentTime },
          },
          window.location.origin,
        );
      } catch (e) {
        // The following line is required for debugging purposes.
        // eslint-disable-next-line no-console
        console.error(e); // nosemgrep
      }

      return state;
    },
  );
};
